import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "hidden sm:block w-1/2 relative rounded-l-[20px] overflow-hidden"
}
const _hoisted_2 = ["src"]

import {
  useSlots,
  computed,
} from "vue";
import XIcon from "@/views/Auth/components/XIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    show: { type: Boolean },
    leftImageAsset: {},
    maxHeight: {},
    maxWidth: {},
    showCloseIcon: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const slots = useSlots();

const props = __props;

const emits = __emit;

const hasLeftSide = computed(() => {
  return !!slots["left-side"] || !!props.leftImageAsset;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200] p-4",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }, [
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-300 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-200 ease-in",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "w-[800px] flex relative",
                style: _normalizeStyle({
              maxHeight: __props.maxHeight || undefined,
              maxWidth: __props.maxWidth || undefined,
            })
              }, [
                (__props.showCloseIcon)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "absolute top-6 right-6 cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
                    }, [
                      _createVNode(XIcon, { class: "text-black" })
                    ]))
                  : _createCommentVNode("", true),
                (hasLeftSide.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _renderSlot(_ctx.$slots, "left-side", {}, () => [
                        _createElementVNode("img", {
                          src: __props.leftImageAsset,
                          alt: "left image",
                          class: "w-full h-full object-cover object-center select-none pointer-events-none"
                        }, null, 8, _hoisted_2)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-col border-y border-r border-ternary bg-white px-4 py-6 sm:pr-6 sm:py-6 w-full", {
                'rounded-[20px] sm:pl-6': !hasLeftSide.value,
                'sm:w-1/2 max-sm:rounded-l-[20px] rounded-r-[20px] sm:pl-10':
                  hasLeftSide.value,
              }])
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ], 2)
              ], 4)
            ]),
            _: 3
          })
        ], 512), [
          [_vShow, __props.show]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})